import React, { useState, useEffect } from 'react';
import { Image } from 'semantic-ui-react';
import "./theme/_main.scss"
/* import FadeInSection from "../../customizations/components/theme/Animations/FadeInSection"
 */import { flattenToAppURL } from '@plone/volto/helpers';
import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import { NarrowContainer, Container } from '../../customizations/components/theme/Container/Container';


const View = (props) => {
    const { data, isEditMode, filteredToolbarProps } = props;

    return (
        <section className="full-width foerderer-block">
            <Container>
                {isEditMode ? (
                    <>
                        <TextLineEdit
                            {...filteredToolbarProps}
                            renderTag="h3"
                            renderClassName=""
                            fieldDataName="title"
                            properties={{ title: data.title }}
                            placeholder="Geben Sie einen Text ein"
                        />
                    </>
                ) : (
                    <h3>
                        {data.title}
                    </h3>
                )}
               
                <div className='ui twelve column grid column-grid icons'>
                    {data.elems && data.elems.map((icon, index) => {
                        return (
                            <div className={`three wide computer twelve wide mobile six wide tablet column`} key={index}>
                                <div className='tile'>
                                    {icon?.image && <Image src={flattenToAppURL(icon?.image['@id'] + '/@@images/image')} alt={icon.alt || `Projektpartner ${index + 1}`} />}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Container>
        </section>

    );
};

export default View;